import { render, staticRenderFns } from "./OfficeCar.vue?vue&type=template&id=2fd8de74&scoped=true&"
import script from "./OfficeCar.vue?vue&type=script&lang=js&"
export * from "./OfficeCar.vue?vue&type=script&lang=js&"
import style0 from "./OfficeCar.vue?vue&type=style&index=0&id=2fd8de74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd8de74",
  null
  
)

export default component.exports